export const ROUTES = {
  BASE: "/",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  GAME: "/game",
  DISCLAIMER: "/disclaimer",
};